import { MultipierResultDelay } from '@/modules/rwdGame/ultraRoulette/BetArea/constants';

export type UltraRouletteMultipier = {
    Number: number;
    Multipier: number;
    delay_time: number;
};

export const convertMultipiers = (
    arr: Array<string>
): Array<UltraRouletteMultipier> => {
    let previousDelayTime = 0;
    return arr.map(v => {
        const tmp = v.split(':');
        const num = Number(tmp[0]);
        const multipier = Number(tmp[1]);
        const delayTime = parseFloat(
            (previousDelayTime + MultipierResultDelay[num]).toFixed(2)
        );
        previousDelayTime = delayTime;
        return {
            Number: num,
            Multipier: multipier,
            delay_time: delayTime,
        };
    });
};
